module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._m(1), _vm._v(" "), _vm._l((_vm.requiredProfileFields), function(field, idx) {
    return _c('tr', [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.requiredFieldsMap[field.value]),
        expression: "requiredFieldsMap[field.value]"
      }],
      staticClass: "form-control",
      class: {
        'error': !_vm.requiredFieldsMap[field.value],
        'warning': _vm.duplicates.includes(_vm.requiredFieldsMap[field.value])
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.requiredFieldsMap, field.value, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("* Select field..")]), _vm._v(" "), _vm._l((_vm.formFields), function(option, oi) {
      return _c('option', {
        attrs: {
          "disabled": ['text-entry', 'header', 'row', 'divider'].includes(option.type)
        },
        domProps: {
          "value": option.name
        }
      }, [_vm._v(_vm._s(_vm._f("striphtml")(option.description)))])
    })], 2), _vm._v(" "), (!_vm.requiredFieldsMap[field.value]) ? _c('label', {
      staticClass: "error small"
    }, [_vm._v("This field is required")]) : _vm._e(), _vm._v(" "), (_vm.duplicates.includes(_vm.requiredFieldsMap[field.value])) ? _c('label', {
      staticClass: "warning small"
    }, [_vm._v("Warning: This field is selected more than once")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('select', {
      staticClass: "form-control",
      attrs: {
        "disabled": "disabled"
      }
    }, _vm._l((_vm.profileFields), function(option, oi) {
      return (option.name == field.value) ? _c('option', {
        domProps: {
          "value": oi
        }
      }, [_vm._v(_vm._s(_vm._f("striphtml")(option.description)))]) : _vm._e()
    }), 0)])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.optionalFieldsMap), function(field, idx) {
    return _c('tr', [_c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.referralField),
        expression: "field.referralField"
      }],
      staticClass: "form-control",
      class: {
        'error': !field.referralField,
        'warning': _vm.duplicates.includes(field.referralField)
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(field, "referralField", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Select field...")]), _vm._v(" "), _vm._l((_vm.formFields), function(option) {
      return _c('option', {
        attrs: {
          "disabled": ['text-entry', 'header', 'row', 'divider'].includes(option.type)
        },
        domProps: {
          "value": option.name
        }
      }, [_vm._v(_vm._s(_vm._f("striphtml")(option.description)))])
    })], 2), _vm._v(" "), (!field.referralField) ? _c('label', {
      staticClass: "error small"
    }, [_vm._v("Please select field")]) : _vm._e(), _vm._v(" "), (_vm.duplicates.includes(field.referralField)) ? _c('label', {
      staticClass: "warning small"
    }, [_vm._v("Warning: This field is selected more than once")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-right": "25px",
        "position": "relative"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.profileField),
        expression: "field.profileField"
      }],
      staticClass: "form-control",
      class: {
        'error': !field.profileField
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(field, "profileField", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v(" Select field...")]), _vm._v(" "), _vm._l((_vm.optionalProfileFields), function(option) {
      return (_vm.optionalNotSelected(option.name, idx)) ? _c('option', {
        attrs: {
          "disabled": ['text-entry', 'header'].includes(option.type)
        },
        domProps: {
          "value": option.name
        }
      }, [_vm._v(_vm._s(_vm._f("striphtml")(option.description)))]) : _vm._e()
    })], 2), _vm._v(" "), (!field.profileField) ? _c('label', {
      staticClass: "error small"
    }, [_vm._v("Please select field")]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "remove-optional-field-btn fa fa-remove",
      on: {
        "click": function($event) {
          return _vm.removeOptionalField(idx)
        }
      }
    })])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": _vm.addOptionalFieldMap
    }
  }, [_vm._v("Add")])])])], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("Fields in current referral form")]), _vm._v(" "), _c('th', [_vm._v("Fields in Profile Form")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Required fields")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Optional fields")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36920c89","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/referral/ReferralMapProfileForm.vue
// module id = 1605
// module chunks = 1